import React from 'react';

const steps = [
  ['Understand', 'We clarify the customer, the business problem, the current constraints, and what a useful result looks like.'],
  ['Scope', 'We define the smallest complete release, the deliverables, timeline, price, exclusions, and expected operating costs.'],
  ['Build', 'You review working progress at clear checkpoints while we design, develop, test, and connect the critical pieces.'],
  ['Launch', 'We deploy, verify the main journeys, document ownership, and agree on handoff or ongoing support.'],
];

const ProcessSteps = () => (
  <section className="bg-[#F6F8FA] px-6 py-20 lg:px-8 lg:py-28">
    <div className="mx-auto max-w-7xl">
      <div className="grid gap-9 lg:grid-cols-[.72fr_1.28fr]">
        <div>
          <p className="section-kicker">A clear process</p>
          <h2 className="mt-4 max-w-lg text-4xl font-semibold leading-[1.04] tracking-[-0.045em] text-[#102A3A] md:text-5xl">Know what is happening and what comes next.</h2>
          <p className="mt-6 max-w-md text-base leading-7 text-[#63747E]">The process changes with the project, but the operating principle does not: reduce uncertainty early and keep decisions visible.</p>
        </div>
        <ol className="border-t border-[#C9D7DD]">
          {steps.map(([title, copy], index) => (
            <li key={title} className="grid gap-4 border-b border-[#C9D7DD] py-7 sm:grid-cols-[70px_180px_1fr] sm:items-start">
              <span className="text-xs font-semibold tabular-nums text-[#176B8A]">0{index + 1}</span>
              <h3 className="text-xl font-semibold tracking-[-0.025em] text-[#102A3A]">{title}</h3>
              <p className="text-sm leading-6 text-[#63747E]">{copy}</p>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);

export default ProcessSteps;
